// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__368ar","content":"styles_content__3q91k","checkbox":"styles_checkbox__2NKhp","checkboxLabel":"styles_checkboxLabel__2GjqG"};